import React from "react";
import "./forgetPasswordPage.css";
import goBackIcon from "../../../resources/assets/goback.svg";
import deemedLogo from "../../../resources/assets/logo.png";
import ForgetPasswordFrom from "components/common/FogetPasswordForm/ForgetPasswordFrom";
import { useNavigate } from "react-router-dom";

function ForgetPasswordPage() {
  const navigate = useNavigate();
  return (
    <div className="loginBgDoc2">
      <div className="wrapper-center2">
        <div className="row log_wrapper2">
          <div className="text-white log_left2">
            <img className="logo-img2" src={deemedLogo} alt="logo" />
            <h4 className="log_saying2">
              A doctor is not a mechanic.
              <br />
              A car doesn't react with a<br />
              mechanic, but a human <br /> being does.
            </h4>
            <h4 className="log_saying_name2">- Randa Haines</h4>
            {/* form */}
          </div>
          <div className="log_right2" style={{ position: "relative" }}>
            <div className="goBackIconWrapper" onClick={() => navigate(-1)}>
              <img src={goBackIcon} alt="goback" />
            </div>
            <ForgetPasswordFrom />
          </div>
        </div>
      </div>
    </div>
  );
}
export { ForgetPasswordPage };
